import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';
import { filterObjects } from '../../../sharpr/matchesAllWords/matchesAllWords.js';

export function SsoAdminRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.SsoAdmin', {
		url: '/admin/sso/admin',
		controllerAs: 'vm',
		controller: SsoAdminCtrl,
		templateUrl: '/ng/hub/Sso/Admin/SsoAdminCtrl.html?' + window.BUILD,
		permission: ['all'],
		resolve: {
			sps: ApiResourcify.endpoint('/sso/sps?scope=system'),
			$title: () => 'Manage SSO',
		},
	});
}

export class SsoAdminCtrl {
	constructor(Api, sps, $scope) {
		'ngInject';
		this.Api = Api;
		this.sps = sps;
		this.sps.forEach(sp => (sp.domainList = sp.domains.join(', ')));
		this.filter = '';
		$scope.$watch('vm.filter', this.runFilter.bind(this));
	}

	runFilter() {
		if (this.filter === '') {
			this.filteredSps = this.sps;
			return;
		}
		const searchIn = ['auth_type', 'sp', 'account', 'hub', 'domainList'];
		this.filteredSps = filterObjects(this.sps, this.filter, searchIn);
	}

	toggleIsActive(sp) {
		this.Api.patch(`/sso/sps/${sp.id}`, { is_active: !sp.is_active });
		sp.is_active = !sp.is_active;
	}
}
